// extracted by mini-css-extract-plugin
export default {"reasonsContainer":"TrainingDays_reasonsContainer__yG76R","header":"TrainingDays_header__x0OY+","noReasons":"TrainingDays_noReasons__WGWNi"};